import { AlphaECircleIcon } from './AlphaECircleIcon';

/**
 * author: Contributors
 * id D1367C3A-1884-4A3E-A90F-0AAB3DDCACF1
 * name alpha-e-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-e-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetECircleIcon = AlphaECircleIcon;
export default AlphabetECircleIcon